module.exports = __webpack_public_path__ + "img/contenedor11.b586d7a5.png";